export default __webpack_public_path__ + "static/media/contact.42db7ffe.svg";